import React from "react";
import PropTypes from "prop-types";
import Button from "@p1s/p1s-common-react/Button";
import classNames from "classnames";
import UrlHelper from "../../utilities/UrlHelper";

class LoginHelp extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            showHelp: false
        };

        this.handleHelpClick = this.handleHelpClick.bind(this);
    }

    handleHelpClick () {
        var helpState = !this.state.showHelp;
        this.setState({ "showHelp": helpState });
    }


    render () {
        var helpDetailsClass = classNames({ hidden: !this.state.showHelp });
        var ssoHelpClass = classNames({ hidden: this.state.showHelp || !this.props.isSsoEnabled });
        const emailLoginHref = `${UrlHelper.getIdentifiUrl()}Auth/EmailLogin${UrlHelper.getQuery()}`;
        return (
            <div id="helpContainer">
                <a id="emailLoginPage"
                    className="btn btn-link secondary-link"
                    href={emailLoginHref}>

                    <i className="material-icons emailLoginIcon">email</i>
                    <div id="emailButtonText">EMAIL ACCOUNT SIGN IN</div>

                </a>
                <Button id="loginHelpDisplayToggle"
                    className="btn btn-link secondary-link"
                    onClick={this.handleHelpClick}>

                    <i className="material-icons helpIcon">&#xE887;</i>
                    <div id="helpButtonText">I NEED HELP LOGGING IN</div>

                </Button>
                <div id="helpDetailsContainer" className={helpDetailsClass}>
                    <div className="panel-body">
                        A user with a 9-digit User ID of 099900010 would enter 0999 for Site ID and 10 for User
                        ID. <br/>
                        <br/>
                        If you forgot your password, contact your Site Administrator to reset
                        it. <br/>
                        <br/>
                        If this problem persists, please contact customer support at
                        1-800-341-0450.
                        <br/>
                        <Button
                            name="btnHelpWidgetOk"
                            onClick={this.handleHelpClick}
                            className="btn btn-secondary-action center-block pull-right">OK</Button>
                    </div>
                </div>
                <div id="ssoHelp" className={ssoHelpClass}>
                    This site is set up to use enterprise credentials for sign in. To continue to your site, click "Sign
                    In".
                    If you entered this Site ID by mistake, enter the correct Site ID to sign in with
                    your {this.props.targetProduct} user ID and password.
                </div>
            </div>
        );
    }
}

LoginHelp.propTypes = {
    targetProduct: PropTypes.any,
    isSsoEnabled: PropTypes.bool
};

export default LoginHelp;
